export default __webpack_public_path__ + "static/media/keke.b9306d92.png";